"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Deferred = function () {
  function Deferred() {
    _classCallCheck(this, Deferred);

    this.isReady = false;
    this.queue = [];
  }

  _createClass(Deferred, [{
    key: "_ready",
    value: function _ready() {
      this.isReady = true;
      var value = this.queue.shift();
      while (value) {
        value();
        value = this.queue.shift();
      }
    }
  }, {
    key: "push",
    value: function push(fn) {
      if (this.isReady) {
        fn();
      } else {
        this.queue.push(fn);
      }
    }
  }, {
    key: "run",
    value: function run(isReady) {
      var _this = this;

      if (isReady()) {
        this._ready();
      } else {
        this.timeout = setTimeout(function () {
          _this.run(isReady);
        }, 100);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }]);

  return Deferred;
}();

exports.default = Deferred;


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/defered.js
// module id = 3
// module chunks = 0